import { InnerContentItem } from "@certn/cascadia-react";
import { components } from "@certn/legacy-api/generated-schemas/people";
import { formatDate } from "@certn/utils";

export function DateSummaryField({
  field,
}: {
  field: components["schemas"]["DateCheckField"];
}) {
  return (
    <InnerContentItem
      label={field.label}
      testID="birth-details-summary-date-of-birth"
    >
      {formatDate(field.value, "MMMM d, yyyy")}
    </InnerContentItem>
  );
}
